import React from 'react';
import classNames from 'classnames';
import BagsLogoIcon from '../assets/images/bags-logo.png';

const websiteUrl = 'https://lasthourtreats.com/';

export const AdBagsWebsite = ({ className }) => {
    return (
        <div
            className={classNames('d-flex flex-column text-center justify-content-center p-3', { [className]: !!className })}
            style={{
                backgroundColor: '#fff3cd',
                borderColor: '#ffeeba'
            }}
        >
            <div className="d-flex justify-content-center mb-2">
                <div className="d-flex align-items-center">
                    <img src={BagsLogoIcon} className="d-inline-block mr-2" style={{ width: '35px' }}
                         alt="Last Hour Treats" /> <h5 className="m-0">Last Hour Treats</h5>
                </div>
            </div>

            <h3 className="font-weight-bold">
                Find Hungry <span className="text-danger">Deals</span>
            </h3>
            
            <div className="d-flex justify-content-center">
                <a href={websiteUrl} className="btn btn-danger" target="_blank">View Website</a>
            </div>
        </div>
    )
};